import { render, staticRenderFns } from "./bindingProductList.vue?vue&type=template&id=76390a38&scoped=true&"
import script from "./bindingProductList.vue?vue&type=script&lang=js&"
export * from "./bindingProductList.vue?vue&type=script&lang=js&"
import style0 from "./bindingProductList.vue?vue&type=style&index=0&id=76390a38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76390a38",
  null
  
)

export default component.exports